// Import project images
import aizelInterior1 from '../images/projects/aizel-interior-1.jpg';
import aizelInterior2 from '../images/projects/aizel-interior-2.jpg';
import aizelWarsan1 from '../images/projects/aizel-warsan-1.jpg';
import aizelWarsan2 from '../images/projects/aizel-warsan-2.jpg';
import maakResidence1 from '../images/projects/maak-residence-1.jpg';
import maakResidence2 from '../images/projects/maak-residence-2.jpg';
import Isbhighway from '../images/projects/Isb-highway-01.png';
import DefenceRaya from '../images/projects/Defence-Raya-1-scaled.jpeg';
import GardenSquare from '../images/projects/Garden-Square-3.jpeg';
import NovaCity from '../images/projects/Nova-City-02.jpg';
import PentaSquarPackage from '../images/projects/Penta-Squar-Package-02-01.jpg';
import PentaPackage from '../images/projects/Penta-Squar-Package-03-01.jpg';
import Corporate from '../images/projects/Untitled-1-1.png';
import USEmbassy from '../images/projects/US-Embassy-1-scaled.jpeg';
import Corporate7 from '../images/projects/IMG_3212-scaled.jpg';
import ItalyEmbacy from '../images/projects/IMG_4389-scaled.jpg';
import GreenStore from '../images/projects/IMG_3212-scaled.jpg';
import KenyaEmbacy from '../images/projects/WhatsApp-Image-2025-07-17-at-16.44.52_a207fcb5.jpg';
import IBECSH from '../images/projects/unnamed-2.webp';
import Parking from '../images/projects/Picture4.jpg';  
import ufonetower from '../images/projects/ufone-tower.jpg';
import Thermal from '../images/projects/Thermal-Muzafaghar-Power_03-1024x767-1.png';
import ArfaKareem from '../images/projects/lahore-pakistan-may-30-2023-600nw-2310356123.webp';
import IsbHighway from '../images/projects/Isb-highway-02.png';
import BRTIII from '../images/projects/BRTS-IIA-3-scaled.jpeg';
import BRTV from '../images/projects/BRTS-V-1-scaled.jpeg';  
import SFC from '../images/projects/sfc1.jpeg';
import I8 from '../images/projects/I8-Interchange.jpg';   
import H8H9 from '../images/projects/H8-H9-Underpass-01.jpg';
import FourNumber from '../images/projects/4-Nos-01.jpg';
import SFCDHA from '../images/projects/SFC-1.jpeg';
import SoanRiver from '../images/projects/Soan-River-Bridge-02.jpg';
import RECEPTAYYIP from '../images/projects/vlcsnap-2025-08-05-10h36m54s838-scaled.png';
import RaviRiver from '../images/projects/WhatsApp-Image-2024-08-24-at-14.42.10_b16bab33.jpg';
import ShahdraMor from '../images/projects/WhatsApp-Image-2024-08-24-at-14.42.12_e7a426d8.jpg';
import BEDIAN from '../images/projects/WhatsApp-Image-2023-12-07-at-12.11.14_403086fc.jpg';
import NAVAL from '../images/projects/Still1019_00003-Copy.png';
import GULBERGGREENS from '../images/projects/IMG_1986-scaled.jpg';



const Projects = [
//     {
//        Id:'1',
//        pImg: maakResidence1,
//        ps1img: maakResidence1,
//        psub1img1: maakResidence2,
//        psub1img2: maakResidence1,
//        title:'Maak Residence Dubai South',  
//        subTitle:'Luxury Residential Development',   
//        description: 'A premium residential development in Dubai South featuring modern architecture and luxurious amenities.',
//        category: 'Residential',
//        location: 'Dubai South, UAE',
//        area: '25,000 sq ft',
//        status: 'Under Construction'
//     },
//     {
//        Id:'2',
//        pImg: aizelWarsan1,
//        ps1img: aizelWarsan1,
//        psub1img1: aizelWarsan2,
//        psub1img2: aizelWarsan1,
//        title:'Aizel Tower Warsan', 
//        subTitle:'Commercial Tower Development',    
//        description: 'A state-of-the-art commercial tower in Warsan featuring contemporary design and sustainable building practices.',
//        category: 'Commercial',
//        location: 'Warsan, Dubai, UAE',
//        area: '45,000 sq ft',
//        status: 'Completed'
//     },
//     {
//       Id:'3',
//       pImg: aizelInterior1,
//       ps1img: aizelInterior1,
//       psub1img1: aizelInterior2,
//       psub1img2: aizelInterior1,
//       title:'Aizel Tower Interior',  
//       subTitle:'Interior Design & Fit-out',   
//       description: 'Comprehensive interior design and fit-out services for the Aizel Tower, creating modern and functional spaces.',
//       category: 'Interior Design',
//       location: 'Warsan, Dubai, UAE',
//       area: '35,000 sq ft',
//       status: 'In Progress'
//    },
//     {
//        Id:'4',
//        pImg: maakResidence2,
//        ps1img: maakResidence2,
//        psub1img1: maakResidence1,
//        psub1img2: maakResidence2,
//        title:'Maak Residence - Phase 2',  
//        subTitle:'Residential Complex Extension', 
//        description: 'Second phase of the Maak Residence development, expanding the luxury residential complex.',
//        category: 'Residential',
//        location: 'Dubai South, UAE',
//        area: '30,000 sq ft',
//        status: 'Planning'
//     },
//     {
//        Id:'5',
//        pImg: maakResidence1,
//        ps1img: maakResidence1,
//        psub1img1: maakResidence2,
//        psub1img2: maakResidence1,
//        title:'Maak Residence - Amenities',  
//        subTitle:'Recreational Facilities',   
//        description: 'Design and construction of recreational facilities and amenities for the Maak Residence development.',
//        category: 'Amenities',
//        location: 'Dubai South, UAE',
//        area: '15,000 sq ft',
//        status: 'Under Construction'
//     },
//     {
//        Id:'6',
//        pImg: aizelInterior2,
//        ps1img: aizelInterior2,
//        psub1img1: aizelInterior1,
//        psub1img2: aizelInterior2,
//        title:'Aizel Tower - Lobby Design', 
//        subTitle:'Grand Entrance & Reception',    
//        description: 'Design and construction of the grand lobby and reception area for the Aizel Tower.',
//        category: 'Interior Design',
//        location: 'Warsan, Dubai, UAE',
//        area: '8,000 sq ft',
//        status: 'Completed'
//     },
//     {
//       Id:'7',
//       pImg: aizelInterior1,
//       ps1img: aizelInterior1,
//       psub1img1: aizelInterior2,
//       psub1img2: aizelInterior1,
//       title:'Aizel Tower - Office Spaces', 
//       subTitle:'Modern Office Interiors',  
//       description: 'Design and fit-out of modern office spaces within the Aizel Tower.',
//       category: 'Interior Design',
//       location: 'Warsan, Dubai, UAE',
//       area: '20,000 sq ft',
//       status: 'In Progress'
//    },
//     {
//        Id:'8',
//        pImg: aizelInterior2,
//        ps1img: aizelInterior2,
//        psub1img1: aizelInterior1,
//        psub1img2: aizelInterior2,
//        title:'Aizel Tower - Common Areas', 
//        subTitle:'Shared Spaces Design',
//        description: 'Design and construction of common areas and shared spaces in the Aizel Tower.',
//        category: 'Interior Design',
//        location: 'Warsan, Dubai, UAE',
//        area: '12,000 sq ft',
//        status: 'Completed'
//     },
//     {
//        Id:'9',
//        pImg: maakResidence2,
//        ps1img: maakResidence2,
//        psub1img1: maakResidence1,
//        psub1img2: maakResidence2,
//        title:'Maak Residence - Landscaping',  
//        subTitle:'Garden & Outdoor Design', 
//        description: 'Landscape design and outdoor space planning for the Maak Residence development.',
//        category: 'Landscaping',
//        location: 'Dubai South, UAE',
//        area: '18,000 sq ft',
//        status: 'Planning'
//     },
//     {
//       Id:'10',
//       pImg: aizelInterior1,
//       ps1img: aizelInterior1,
//       psub1img1: aizelInterior2,
//       psub1img2: aizelInterior1,
//       title:'Aizel Tower - Retail Spaces',  
//       subTitle:'Commercial Interior Design',   
//       description: 'Design and fit-out of retail and commercial spaces in the Aizel Tower.',
//       category: 'Interior Design',
//       location: 'Warsan, Dubai, UAE',
//       area: '25,000 sq ft',
//       status: 'In Progress'
//    },
//    {
//       Id:'11',
//       pImg: maakResidence1,
//       ps1img: maakResidence1,
//       psub1img1: maakResidence2,
//       psub1img2: maakResidence1,
//       title:'Maak Residence - Parking', 
//       subTitle:'Underground Parking Design',    
//       description: 'Design and construction of underground parking facilities for the Maak Residence.',
//       category: 'Infrastructure',
//       location: 'Dubai South, UAE',
//       area: '40,000 sq ft',
//       status: 'Under Construction'
//    },
   {
     Id:'1',
     pImg: aizelWarsan2,
     ps1img: aizelWarsan2,
     psub1img1: aizelWarsan1,
     psub1img2: aizelWarsan2,
     title:'Aizel Tower - Exterior',  
     subTitle:'Facade & Building Envelope',   
     description: 'Design and construction of the building facade and exterior envelope for the Aizel Tower.',
     category: 'Architecture',
     location: 'Warsan, Dubai, UAE',
     area: '50,000 sq ft',
     status: 'Completed'
  },
   {
     Id:'2',
     pImg: maakResidence2,
     ps1img: maakResidence2,
     psub1img1: maakResidence1,
     psub1img2: maakResidence2,
     title:'Maak Residence - Security',  
     subTitle:'Security Systems Integration',   
     description: 'Integration of security systems and access control for the Maak Residence development.',
     category: 'Security',
     location: 'Dubai South, UAE',
     area: '25,000 sq ft',
     status: 'In Progress'
  },
//    {
//      Id:'14',
//      pImg: aizelInterior1,
//      ps1img: aizelInterior1,
//      psub1img1: aizelInterior2,
//      psub1img2: aizelInterior1,
//      title:'Aizel Tower - HVAC',  
//      subTitle:'Mechanical Systems',   
//      description: 'Design and installation of HVAC and mechanical systems for the Aizel Tower.',
//      category: 'MEP',
//      location: 'Warsan, Dubai, UAE',
//      area: '45,000 sq ft',
//      status: 'Completed'
//   },
   {
     Id:'3',
     pImg: maakResidence1,
     ps1img: maakResidence1,
     psub1img1: maakResidence2,
     psub1img2: maakResidence1,
     title:'Maak Residence - Electrical',  
     subTitle:'Electrical Systems Design',   
     description: 'Design and installation of electrical systems and lighting for the Maak Residence.',
     category: 'MEP',
     location: 'Dubai South, UAE',
     area: '25,000 sq ft',
     status: 'Under Construction'
  },
   {
     Id:'4',
     pImg: aizelInterior2,
     ps1img: aizelInterior2,
     psub1img1: aizelInterior1,
     psub1img2: aizelInterior2,
     title:'Aizel Tower - Fire Safety',  
     subTitle:'Fire Protection Systems',   
     description: 'Design and installation of fire safety and protection systems for the Aizel Tower.',
     category: 'Safety',
     location: 'Warsan, Dubai, UAE',
     area: '45,000 sq ft',
     status: 'Completed'
  },
   {
     Id:'5',
     pImg: aizelInterior1,
     ps1img: aizelInterior1,
     psub1img1: aizelInterior2,
     psub1img2: aizelInterior1,
     title:'Aizel Tower - Smart Systems',  
     subTitle:'Building Automation',   
     description: 'Integration of smart building systems and automation for the Aizel Tower.',
     category: 'Technology',
     location: 'Warsan, Dubai, UAE',
     area: '45,000 sq ft',
     status: 'In Progress'
  },
   {
     Id:'6',
     pImg: maakResidence2,
     ps1img: maakResidence2,
     psub1img1: maakResidence1,
     psub1img2: maakResidence2,
     title:'Maak Residence - Sustainability',  
     subTitle:'Green Building Features',    
     description: 'Implementation of sustainable and green building features for the Maak Residence development.',
     category: 'Sustainability',
     location: 'Dubai South, UAE',
     area: '25,000 sq ft',
     status: 'Planning'
  },
  {
   Id:'7',
   pImg: Isbhighway,
   ps1img: Isbhighway,
   psub1img1: Isbhighway,
   psub1img2: Isbhighway,
   title:'Maak Residence Islambad Highway',  
   subTitle:'Green Building Features',    
   description: 'Implementation of sustainable and green building features for the Maak Residence development.',
   category: 'Sustainability',
   location: 'Islambad Highway, Pakistan',
   area: '25,000 sq ft',
   status: 'Completed'
  },
  {
    Id:'8',
    pImg: DefenceRaya,
    ps1img: maakResidence1,
    psub1img1: DefenceRaya,
    psub1img2: maakResidence1,
    title:'Defence Raya Golf & Country Club',
    subTitle:'Luxury Recreational Development',
    description: 'Works included landscaping and upgrading of CDA Nursery, enhancements along Srinagar Highway, creation of a Pakistan Map installation, improvements at G-6 Melody and Saidpur Village, facade works at the Convention Center, painting of bridges on Islamabad Expressway, and finishing works at 7th Avenue Interchange.',
    category: 'Recreational',
    location: 'Islamabad, Pakistan',
    area: '25,000 sq ft',
    status: 'Under Construction'
  },
  {
    Id:'9',
    pImg: GardenSquare,
    ps1img: GardenSquare,
    psub1img1: GardenSquare,
    psub1img2: GardenSquare,
    title:'Garden Square',
    subTitle:'Economic Housing Scheme',
    description: 'Garden Square Developers project in Eminabad is an economic housing scheme. The initiative has public benefit and is a first-of-its-kind private sector partnership to provide low-income households with cutting-edge housing. Our main goal is to provide everyone with high-quality service at a reasonable cost of living. As one of the largest economic projects in Pakistan\'s history, the \'Naya Pakistan Housing Scheme,\' which is Prime Minister Imran Khan\'s vision for affordable housing, is meant to be realized through the partnership.',
    category: 'Residential',
    location: 'Islamabad, Pakistan',
    area: '30,000 sq ft',
    status: 'In Progress'
  },
  {
    Id:'10',
    pImg: NovaCity,
    ps1img: NovaCity,
    psub1img1: NovaCity,
    psub1img2: NovaCity,
    title:'Nova City',
    subTitle:'Luxury Housing Society',
    description: 'Nova Group has developed the magnificent housing Society Nova City Islamabad, which is also responsible for many renowned luxury housing ventures in the different cities of Pakistan. Maaksons has been awarded the complete infrastructure works development of Nova City Islamabad and Nova City Peshawar.',
    category: 'Residential',
    location: 'Islamabad, Pakistan',
    area: '45,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'11',
    pImg: PentaSquarPackage,
    ps1img: PentaSquarPackage,
    psub1img1: PentaSquarPackage,
    psub1img2: PentaSquarPackage,
    title:'Penta Square (Block A & B) Package 02',
    subTitle:'Commercial Development',
    description: 'Rooms in A, G+2 Rooms Club, Full MERW, and firefighting system are integrating a robust structural design road map for commercial and residential needs.',
    category: 'Commercial',
    location: 'Islamabad, Pakistan',
    area: '35,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'12',
    pImg: PentaPackage,
    ps1img: PentaPackage,
    psub1img1: PentaPackage,
    psub1img2: PentaPackage,
    title:'Penta Square (Block A & B) Package 03',
    subTitle:'Commercial Development',
    description: '7530 sq. ft safety measures, bolstering the foundation for a high-performance hub with integration and advanced firefighting system.',
    category: 'Commercial',
    location: 'Islamabad, Pakistan',
    area: '7,530 sq ft',
    status: 'Completed'
  },
  {
    Id:'13',
    pImg: Corporate,
    ps1img: Corporate,
    psub1img1: Corporate,
    psub1img2: Corporate,
    title:'Corporate 7',
    subTitle:'Corporate Building',
    description: 'The CDA approved corporate building in Gulberg Greens, Islamabad featuring a smart building with high-speed elevators, security, and state-of-the-art facilities, setting new benchmarks for corporate architecture.',
    category: 'Commercial',
    location: 'Islamabad, Pakistan',
    area: '20,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'14',
    pImg: USEmbassy,
    ps1img: USEmbassy,
    psub1img1: USEmbassy,
    psub1img2: USEmbassy,
    title:'USA Embassy - Diplomatic Enclave',
    subTitle:'Embassy Construction',
    description: 'Designed with a focus on green roads, automated systems, underground utilities, and secured entry features. Built to international standards.',
    category: 'Government',
    location: 'Islamabad, Pakistan',
    area: '30,000 sq ft',
    status: 'Completed'
  },
  {   
    Id:'15',
    pImg: Corporate7,
    ps1img: Corporate7,
    psub1img1: Corporate7,
    psub1img2: Corporate7,
    title:'Corporate 5',
    subTitle:'Corporate Enclave',
    description: 'An innovative corporate enclave building in Gulberg Greens, Islamabad with modern architecture, advanced systems, and a secured perimeter. Surrounded by lush greenery, integrated smart features, high-speed elevators, and secure access points.',
    category: 'Commercial',
    location: 'Islamabad, Pakistan',
    area: '25,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'16',
    pImg: ItalyEmbacy,
    ps1img: ItalyEmbacy,
    psub1img1: ItalyEmbacy,
    psub1img2: ItalyEmbacy,
    title:'Embassy of Italy - Diplomatic Enclave',
    subTitle:'Embassy Construction',
    description: 'Includes full MERW systems, automated drainage, and upgraded water systems. Built to international standards with advanced security features.',
    category: 'Government',
    location: 'Islamabad, Pakistan',
    area: '40,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'17',
    pImg: GreenStore,
    ps1img: GreenStore,
    psub1img1: GreenStore,
    psub1img2: GreenStore,
    title:'Green Store - Khaadi',
    subTitle:'Retail Store Design',
    description: 'The store maintains green temperature cooling systems with modern electrical designs, ensuring energy efficiency and retail design in a friendly atmosphere.',
    category: 'Commercial',
    location: 'Islamabad, Pakistan',
    area: '15,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'18',
    pImg: KenyaEmbacy,
    ps1img: KenyaEmbacy,
    psub1img1: KenyaEmbacy,
    psub1img2: KenyaEmbacy,
    title:'Kenya Embassy - Diplomatic Enclave',
    subTitle:'Embassy Renovation',
    description: 'Comprehensive renovation of the embassy and outside facilities including roof repairs, wall treatments, and installation of modern building systems.',
    category: 'Government',
    location: 'Islamabad, Pakistan',
    area: '20,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'19',
    pImg: IBECSH,
    ps1img: IBECSH,
    psub1img1: IBECSH,
    psub1img2: IBECSH,
    title:'Ibechs Headquarters - Gulberg Greens',
    subTitle:'Administrative Facility',
    description: 'The administrative facility is the intelligence bureau\'s Employees Housing Society, located in Gulberg Greens, providing offices and infrastructure that reflects the organization\'s commitment to quality housing development.',
    category: 'Government',
    location: 'Islamabad, Pakistan',
    area: '30,000 sq ft',
    status: 'In Progress'
  },
  {
    Id:'20',
    pImg: Parking,
    ps1img: Parking,
    psub1img1: Parking,
    psub1img2: Parking,
    title:'Park & Ride - Parking Plaza',
    subTitle:'Parking Facility',
    description: 'A state-of-the-art facility designed to support urban parking needs, featuring reinforced concrete construction, automated systems, and efficient urban mobility solutions.',
    category: 'Infrastructure',
    location: 'Islamabad, Pakistan',
    area: '50,000 sq ft',
    status: 'Planning'
  },
  {
    Id:'21',
    pImg: ufonetower,
    ps1img: ufonetower,
    psub1img1: ufonetower,
    psub1img2: ufonetower,
    title:'Ptet Telecom Tower',
    subTitle:'Telecom Infrastructure',
    description: 'A high-rise telecom tower with modern communication infrastructure, featuring reinforced concrete construction and energy-efficient systems.',
    category: 'Infrastructure',
    location: 'Islamabad, Pakistan',
    area: '40,000 sq ft',
    status: 'Under Construction'
  },
  {
    Id:'22',
    pImg: Thermal,
    ps1img: Thermal,
    psub1img1: Thermal,
    psub1img2: Thermal,
    title:'Thermal Power Station',
    subTitle:'Power Generation',
    description: 'Construction of a large generating facility featuring industrial boilers, turbines, and advanced energy systems with safety measures to the plant\'s design.',
    category: 'Infrastructure',
    location: 'Islamabad, Pakistan',
    area: '100,000 sq ft',
    status: 'In Progress'
  },
  {
    Id:'23',
    pImg: ArfaKareem,
    ps1img: ArfaKareem,
    psub1img1: ArfaKareem,
    psub1img2: ArfaKareem,
    title:'Arfa Karim Command & Control Center',
    subTitle:'IT & Surveillance Facility',
    description: 'A state of the art IT and surveillance facility designed to manage Lahore’s city operations. The building features advanced surveillance systems, traffic control, and security measures.',
    category: 'Technology',
    location: 'Lahore, Pakistan',
    area: '60,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'24',
    pImg: IsbHighway,
    ps1img: IsbHighway,
    psub1img1: IsbHighway,
    psub1img2: IsbHighway,
    title:'Signal Free Corridor - Islamabad Expressway',
    subTitle:'Traffic Infrastructure',
    description: 'Interchange and traffic underpass drainage. Designed for public traffic efficiency and aesthetics, significant project to transform commuting.',
    category: 'Infrastructure',
    location: 'Islamabad, Pakistan',
    area: '50,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'25',
    pImg: BRTIII,
    ps1img: BRTIII,
    psub1img1: BRTIII,
    psub1img2: BRTIII,
    title:'Brts Project - Package VIII',
    subTitle:'Transit System',
    description: 'Development of a 13-km elevated transit system along Lahore’s Ferozepur Road, including dual carriageways, 24/7 operations, and advanced transit infrastructure.',
    category: 'Transportation',
    location: 'Lahore, Pakistan',
    area: '150,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'26',
    pImg: BRTV,
    ps1img: BRTV,
    psub1img1: BRTV,
    psub1img2: BRTV,
    title:'Brts Project - Package V',
    subTitle:'Transit Lane',
    description: 'Execution of a 3-km elevated transit lane with barriers, integrated with lane arrangements and advanced lighting systems.',
    category: 'Transportation',
    location: 'Islamabad, Pakistan',
    area: '40,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'27',
    pImg: SFC,
    ps1img: SFC,
    psub1img1: SFC,
    psub1img2: SFC,
    title:'Signal Free Corridor - Walton Road',
    subTitle:'Traffic Improvement',
    description: 'Junction remodeling, traffic light construction, LESCO-coordinated 11-kV street lighting, and modern urban infrastructure enhancements.',
    category: 'Infrastructure',
    location: 'Lahore, Pakistan',
    area: '30,000 sq ft',
    status: 'Completed'
  },
//   {
//     Id:'40',
//     pImg: maakResidence1,
//     ps1img: maakResidence1,
//     psub1img1: maakResidence2,
//     psub1img2: maakResidence1,
//     title:'Brts Project - Package IIIA',
//     subTitle:'Elevated Transit',
//     description: 'A 14-km stretch of elevated transit lanes with dual carriageways, firefighting systems, and enhanced accessibility features.',
//     category: 'Transportation',
//     location: 'Islamabad, Pakistan',
//     area: '200,000 sq ft',
//     status: 'Completed'
//   },
  {
    Id:'28',
    pImg: I8,
    ps1img: I8,
    psub1img1: I8,
    psub1img2: I8,
    title:'I-8 Interchange',
    subTitle:'Traffic Interchange',
    description: 'A major interchange featuring a 3-lane elevated structure, underground utilities, traffic control systems, and enhanced safety features.',
    category: 'Infrastructure',
    location: 'Islamabad, Pakistan',
    area: '50,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'29',
    pImg: H8H9,
    ps1img: H8H9,
    psub1img1: H8H9,
    psub1img2: H8H9,
    title:'H-8 / H-9 Underpass',
    subTitle:'Traffic Underpass',
    description: 'The twin underpass project featured multi-lane passage with a 3-lane structure including traffic control systems and modern infrastructure elements.',
    category: 'Infrastructure',
    location: 'Islamabad, Pakistan',
    area: '40,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'30',
    pImg: FourNumber,
    ps1img: FourNumber,
    psub1img1: FourNumber,
    psub1img2: FourNumber,
    title:'4 - Number of Bridges',
    subTitle:'Bridge Construction',
    description: 'Construction of four bridges over Rawal Highway in Islamabad, works improved traffic flow, reducing travel time, and enhancing safety. Completed with stable scheduling.',
    category: 'Infrastructure',
    location: 'Islamabad, Pakistan',
    area: '60,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'31',
    pImg: SFCDHA,
    ps1img: SFCDHA,
    psub1img1: SFCDHA,
    psub1img2: SFCDHA,
    title:'Signal Free Corridor - DHA',
    subTitle:'Traffic Enhancement',
    description: 'Replacement of traffic signals with underpasses and bridges, modern pavement construction, LESCO-supplied 11-kV street lighting, landscaping, and concrete drainage systems.',
    category: 'Infrastructure',
    location: 'Islamabad, Pakistan',
    area: '70,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'32',
    pImg: SoanRiver,
    ps1img: SoanRiver,
    psub1img1: SoanRiver,
    psub1img2: SoanRiver,
    title:'Soan River Bridge',
    subTitle:'Bridge Construction',
    description: 'Construction of a 2-lane bridge over the Soan River with a 34-meter wide carriageway and 2.5-meter sidewalks, featuring regional landscaping and traffic enhancements.',
    category: 'Infrastructure',
    location: 'Islamabad, Pakistan',
    area: '50,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'33',
    pImg: RECEPTAYYIP,
    ps1img: RECEPTAYYIP,
    psub1img1: RECEPTAYYIP,
    psub1img2: RECEPTAYYIP,
    title:'Receiptayyip Erdogan Interchange',
    subTitle:'Traffic Interchange',
    description: 'A 6-lane elevated structure with modern underpass, landscaping, and traffic design components.',
    category: 'Infrastructure',
    location: 'Islamabad, Pakistan',
    area: '80,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'34',
    pImg: RaviRiver,
    ps1img: RaviRiver,
    psub1img1: RaviRiver,
    psub1img2: RaviRiver,
    title:'Ravi Bridge',
    subTitle:'River Bridge',
    description: 'A modern infrastructure project spanning the Ravi River, designed to handle traffic with modern engineering standards. The bridge includes robust drainage and approach roads to improve connectivity.',
    category: 'Infrastructure',
    location: 'Lahore, Pakistan',
    area: '70,000 sq ft',
    status: 'In Progress'
  },
  {
    Id:'35',
    pImg: ShahdraMor,
    ps1img: ShahdraMor,
    psub1img1: ShahdraMor,
    psub1img2: ShahdraMor,
    title:'Shahdarra Morr',
    subTitle:'Road Upgrade',
    description: 'Upgrading of the Shahdara Morr to a 3-lane road with RCC culverts, traffic signals, and landscaping enhancements, improving mobility and safety.',
    category: 'Infrastructure',
    location: 'Lahore, Pakistan',
    area: '40,000 sq ft',
    status: 'Planning'
  },
  {
    Id:'36',
    pImg: BEDIAN,
    ps1img: BEDIAN,
    psub1img1: BEDIAN,
    psub1img2: BEDIAN,
    title:'Bedien Underpass',
    subTitle:'Traffic Underpass',
    description: 'A modern underpass to improve junction traffic in Lahore, featuring reinforced concrete structures, traffic control systems, and enhanced safety features.',
    category: 'Infrastructure',
    location: 'Lahore, Pakistan',
    area: '30,000 sq ft',
    status: 'Under Construction'
  },
  {
    Id:'37',
    pImg: NAVAL,
    ps1img: NAVAL,
    psub1img1: NAVAL,
    psub1img2: NAVAL,
    title:'Naval Anchorage Interchange',
    subTitle:'Traffic Interchange',
    description: 'Featuring traffic signals, drainage, and landscaping enhancements to improve traffic flow and safety at one of the busiest corridors.',
    category: 'Infrastructure',
    location: 'Islamabad, Pakistan',
    area: '60,000 sq ft',
    status: 'Completed'
  },
  {
    Id:'38',
    pImg: GULBERGGREENS,
    ps1img: GULBERGGREENS,
    psub1img1: GULBERGGREENS,
    psub1img2: GULBERGGREENS,
    title:'Gulberg Greens Interchange',
    subTitle:'Traffic Interchange',
    description: 'An important Islamabad Expressway interchange linking the city with Gulberg Greens. The project includes modern traffic management systems and efficient urban design.',
    category: 'Infrastructure',
    location: 'Islamabad, Pakistan',
    area: '70,000 sq ft',
    status: 'Completed'
  }
];

export default Projects;
